<h1 mat-dialog-title>Aviso</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Ok</button>
</div>
